import { Component, HostBinding, Input, OnInit } from '@angular/core';

export type AppSpinnerAlign = 'left' | 'center' | 'right';
export type AppSpinnerColor = 'default' | 'white';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  // spinner size
  @Input() size = 20;
  // container height
  @Input() height: number;
  // spinner align
  @Input() @HostBinding('attr.ts-align') align: AppSpinnerAlign = 'center';
  // spinner color
  @Input() @HostBinding('attr.ts-color') color: AppSpinnerColor = 'default';
  // spinner border width
  @Input() borderWidth = 2;
  // the period time of the animation (might use bigger values for larger spinners)
  @Input() periodSec = 0.7;
  // get host height
  @HostBinding('style.height') get hostHeight(): string {
    return this.height ? `${this.height}px` : null;
  }

  constructor() {}

  ngOnInit(): void {}
}
